/* 17c: shared 15b height/opacity disclosure, native details remain usable without JS. */
if (!window.MCAnimatedDetails) {
  window.MCAnimatedDetails = class extends HTMLElement {
    connectDisclosure(bodySelector, contentSelector, closingClass = 'mc-details--closing') {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.body = this.querySelector(bodySelector);
      this.content = this.querySelector(contentSelector);
      this.closingClass = closingClass;
      this.expanded = this.details.open;
      this.lifecycle = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.summary.addEventListener('click', event => { event.preventDefault(); this.setExpanded(!this.expanded); }, { signal:this.lifecycle.signal });
      this.details.addEventListener('toggle', () => { if (!this.animation) this.expanded = this.details.open; }, { signal:this.lifecycle.signal });
      this.motion.addEventListener('change', () => this.finishMotion(), { signal:this.lifecycle.signal });
    }
    connectButtonDisclosure(bodySelector, contentSelector, buttonSelector) {
      this.details = null;
      this.summary = this.querySelector(buttonSelector);
      this.body = this.querySelector(bodySelector);
      this.content = this.querySelector(contentSelector);
      this.expanded = false;
      this.lifecycle = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.summary.addEventListener('click', () => this.setExpanded(!this.expanded), { signal:this.lifecycle.signal });
      this.motion.addEventListener('change', () => this.finishMotion(), { signal:this.lifecycle.signal });
      this.applyExpandedState();
    }
    applyExpandedState() {
      if (this.details) {
        this.details.open = this.expanded;
        this.details.classList.remove(this.closingClass);
      } else {
        this.toggleAttribute('data-expanded', this.expanded);
        this.summary.setAttribute('aria-expanded', String(this.expanded));
        this.summary.querySelector('[data-mc-disclosure-label]').textContent = this.expanded ? this.summary.dataset.openLabel : this.summary.dataset.closedLabel;
      }
    }
    finishMotion() {
      this.animation?.cancel(); this.fade?.cancel(); this.animation = null;
      this.body.style.height = ''; this.applyExpandedState();
    }
    animateHeight(from, to, close = false, opening = false) {
      if (this.motion.matches || !this.body.animate || Math.abs(from - to) < 1) { this.finishMotion(); return; }
      this.animation?.cancel();
      const animation = this.body.animate([{height:`${from}px`,opacity:opening?0:1},{height:`${to}px`,opacity:close?0:1}], {duration:250,easing:'ease-out'});
      this.animation = animation;
      animation.onfinish = () => {
        if (this.animation !== animation) return;
        if (close) this.applyExpandedState();
        this.body.style.height = ''; this.animation = null;
      };
    }
    setExpanded(open) {
      const from = (this.details ? this.details.open : this.expanded) ? this.body.getBoundingClientRect().height : 0;
      this.animation?.cancel(); this.animation = null; this.fade?.cancel();
      this.expanded = open;
      if (this.details) this.details.classList.toggle(this.closingClass, !open);
      else this.applyExpandedState();
      this.body.style.height = ''; if (open && this.details) this.details.open = true;
      this.animateHeight(from, open ? this.content.getBoundingClientRect().height : 0, !open, open && from === 0);
    }
    fadeContent() {
      if (!this.motion.matches && this.content.animate) this.fade = this.content.animate([{opacity:.5},{opacity:1}], {duration:120,easing:'ease-out'});
    }
    disconnectDisclosure() { this.lifecycle?.abort(); this.animation?.cancel(); this.fade?.cancel(); }
  };
}
